import React from 'react';
import { useHistory } from 'react-router-dom';

import TableHeader from '../../../../components/Table/TableHeader';
import TablePagination from '../../../../components/Table/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import InputSearch from '../../../../components/InputSearch'

const tabelaColunas = ['#Filial', 'Razão Social', 'Nome Fantasia', 'CNPJ', 'UF', 'Cidade', 'Status', '']

const PefilSellerListFilial = ({ response, buscar, busca, mudarPagina }) => {

    const history = useHistory();
    const changePage = (page) => {
        mudarPagina(page)
    }

    const gotoDet = (idFilialSeller) => {
        history.push(`/seller/filial/${idFilialSeller}`);
    }

    return (
        <div>
            <div className="row justify-content-end">
                <div className='col-md-3'>
                    <FormControl>
                        <InputSearch
                            buscar={buscar}
                            buscaPor={busca}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className='col-12 mt20'>
                    <div className="table-responsive">
                        <table className="table">
                            <TableHeader columns={tabelaColunas} />

                            <tbody>
                                {
                                    (!response?.lista || response?.lista.length === 0) &&
                                    <tr><td colSpan="7"> Sem Registros </td></tr>
                                }
                                {
                                    response?.lista && response?.lista?.map((filial) => (
                                        <tr key={filial.id}>
                                            <td> {`00000${filial.codigo}`} </td>
                                            <td> {filial.razaoSocial} </td>
                                            <td> {filial.nomeFantasia} </td>
                                            <td> {filial.cnpj} </td>
                                            <td> {filial.uf} </td>
                                            <td> {filial.cidade} </td>
                                            <td> {filial.ativo ? 'Ativo' : 'Inativo'} </td>
                                            <td className="text-right">
                                                <i className="btn-edit-icon btn btn-icon fa fa-edit" onClick={() => gotoDet(filial.id)}></i>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <TablePagination data={response} changePage={changePage} />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PefilSellerListFilial;